import {
  DEFAULT_SEARCH_TAG_SEPARATORS,
  SEARCH_TAG_SEPARATORS_BY_FIELD
} from '../constants/searchTagSeparator.constant';

/**
 * Returns the characters splitting a pasted list into search tags for the given filter definition.
 */
export function getSearchTagSeparators(fieldName: string): string[] {
  return SEARCH_TAG_SEPARATORS_BY_FIELD[fieldName] ?? DEFAULT_SEARCH_TAG_SEPARATORS;
}
